import { Link } from '../components'
export function PageViewLink({
  className,
  disabled,
  url,
  children,
  variant,
  paddingClass,
}: {
  className?: string
  variant: 'solid' | 'outlined'
  disabled?: boolean
  url: string
  children?: string | React.ReactElement
  paddingClass?: string
}): React.ReactElement {
  const padding = paddingClass || 'px-12'
  const baseClass = `mt-4 py-3 block rounded bg-purple text-md text-white hover:bg-purple-dark ${padding}`
  const disabledClass = 'disabled:opacity-75 disabled:cursor-not-allowed disabled:bg-purple'

  const outLined = `mt-4 text-purple py-3 block rounded ring-2 ring-purple hover:bg-purple hover:text-white   ${padding}`

  return (
    <>
      <Link
        className={`${variant === 'solid' ? baseClass : outLined} ${disabledClass} ${className}`}
        disabled={disabled}
        to={url}
      >
        {children}
      </Link>
    </>
  )
}
